import { createSelector } from 'reselect';

import { editorSelector } from 'modules/editor/store/selectors/editor';

import { getResetState, getResetSectionState } from './utils';

export const resetStateSelector = createSelector(editorSelector, getResetState);
export const resetSectionStateSelector = createSelector(editorSelector, getResetSectionState);
